var lastTop = window.pageYOffset || document.documentElement.scrollTop;

const customMethods = {
  run: function () {
    this.slider();
    this.videoPlay();
    this.scrollPauseVideo();
    this.checkCenter();
    this.dripScroll();
    this.cupTouch();
  },

  _liquidTop: null,
  _played: false,
  dripScroll: function () {
    var comp = document.querySelector('.morph_animation-components');
    var liquid = document.querySelector('.morph_animation-components .liquid');
    if (!comp || !liquid) return;

    if (this._liquidTop == null) {
      var t = 0, node = liquid;
      while (node) { t += node.offsetTop; node = node.offsetParent; }
      this._liquidTop = t;
    }

    var engageY = this._liquidTop - window.innerHeight * 0.5; // 水滴顶部到达 50vh 时的 scrollY

    if (window.pageYOffset >= engageY) {
      if (!this._played) { this._played = true; comp.classList.remove('drip-reverse'); comp.classList.add('drip-play'); }
    } else {
      if (this._played) { this._played = false; comp.classList.remove('drip-play'); comp.classList.add('drip-reverse'); }
    }
  },

  cupTouch: function () {
    var liquid = document.querySelector('.morph_animation-components .liquid');
    var cup = document.querySelector('.morph_animation-components .cup');
    if (!liquid || !cup) return;

    var LEAD = 150;
    var dropBottom = window.innerHeight * 0.5 + liquid.offsetHeight;
    var cupTop = cup.getBoundingClientRect().top + 40;

    var p = (dropBottom + LEAD - cupTop) / LEAD;
    p = Math.max(0, Math.min(1, p));

    if (window.innerWidth > 1199) {
      liquid.style.transform = 'translateX(-43%) scale(' + (1 - p) + ')';
    } else if (window.innerWidth > 767) {
      liquid.style.transform = 'translateX(-51%) scale(' + (1 - p) + ')';
    } else {
      liquid.style.transform = 'translateX(-31%) scale(' + (1 - p) + ')';
    }
  },

  benefitsSwiper: null,

  initBenefitsSwiper: function () {
    var self = this;
    var el = document.querySelector('.benefits-swiper');
    if (!el) return;

    var mq = window.matchMedia('(max-width: 575.98px)');

    function create() {
      if (self.benefitsSwiper) return;
      self.benefitsSwiper = new Swiper('.benefits-swiper', {
        slidesPerView: 1.2,
        spaceBetween: 18,
        navigation: {
          nextEl: '.morph_swiper-button-next',
          prevEl: '.morph_swiper-button-prev',
        },
        breakpoints: {
          576: { slidesPerView: 2, spaceBetween: 20 },
          1200: { slidesPerView: 3, spaceBetween: 37 }
        }
      });
    }

    function destroy() {
      if (self.benefitsSwiper) {
        self.benefitsSwiper.destroy(true, true);
        self.benefitsSwiper = null;
      }
    }

    function apply() {
      var noSwiperMobile = el.classList.contains('mobile-noswiper');
      if (noSwiperMobile && mq.matches) {
        destroy();
      } else {
        create();
      }
    }

    apply();

    if (mq.addEventListener) {
      mq.addEventListener('change', apply);
    } else {
      mq.addListener(apply);
    }
  },

  slider: function () {
    if (document.querySelector('.fun-fact-swiper')) {
      var funFactSwiper = new Swiper(".fun-fact-swiper", {
        effect: 'fade',
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    }

    if (document.querySelector('.benefits-swiper')) {
      this.initBenefitsSwiper();
    }

    if (document.querySelector('.happy-bone-heads-swiper')) {
      document.querySelectorAll('.happy-bone-heads-swiper .swiper-slide').forEach(function (slide, i) {
        var item = slide.querySelector('.morph_item');
        if (!item) return;
        if (i % 3 == 1) {
          item.classList.add('blue');
        } else if (i % 3 == 2) {
          item.classList.add('red');
        } else {
          item.classList.add('yellow');
        }
      });

      var happyBoneHeadsSwiper = new Swiper(".happy-bone-heads-swiper", {
        slidesPerView: 1,
        spaceBetween: 20,
        centeredSlides: true,
        loop: true,
        navigation: {
          nextEl: '.morph_swiper-button-next',
          prevEl: '.morph_swiper-button-prev',
        },
        breakpoints: {
          768: {
            slidesPerView: 1.5,
            spaceBetween: 20
          },
          992: {
            slidesPerView: 2,
            spaceBetween: 40
          }
        }
      });
    }

    if (document.querySelector('.bone-broth-swiper')) {
      var boneBrothSwiper = new Swiper(".bone-broth-swiper", {
        slidesPerView: 1.2,
        spaceBetween: 21,
        centeredSlides: true,
        loop: true,
        breakpoints: {
          576: {
            slidesPerView: 2,
            spaceBetween: 21
          },
          992: {
            slidesPerView: 3,
            spaceBetween: 40
          }
        }
      });
    }

    if (document.querySelector('.make-it-now-swiper')) {
      var happyBoneHeadsSwiper = new Swiper(".make-it-now-swiper", {
        slidesPerView: 1,
        spaceBetween: 20,
        navigation: {
          nextEl: '.morph_swiper-button-next',
          prevEl: '.morph_swiper-button-prev',
        },
        breakpoints: {
          576: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          1050: {
            slidesPerView: 3,
            spaceBetween: 40
          }
        }
      });
    }
  },

  videoPlay: function () {
    document.body.addEventListener('click', function (e) {
      var box = e.target.closest('.morph_media-box');
      if (!box) return;
      if (e.target.tagName === 'VIDEO') {
        e.preventDefault();
      }
      box.classList.toggle('playing');
      var playing = box.classList.contains('playing');
      box.querySelectorAll('video').forEach(function (video) {
        var visible = video.offsetParent !== null;
        if (playing && visible) {
          video.play();
        } else {
          video.pause();
        }
      });
    });
  },

  scrollPauseVideo: function () {
    var boxes = document.querySelectorAll('.morph_video-model .morph_media-box');
    if (!boxes.length || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var box = entry.target;
        if (!box.classList.contains('playing')) return;

        var video = Array.prototype.find.call(box.querySelectorAll('video'), function (v) {
          return v.offsetParent !== null;
        });
        if (!video) return;

        if (!entry.isIntersecting) {
          if (!video.paused) {
            video.pause();
            box.dataset.autoPaused = 'true';
          }
        } else if (box.dataset.autoPaused === 'true') {
          video.play();
          delete box.dataset.autoPaused;
        }
      });
    }, { threshold: 0 });

    boxes.forEach(function (box) {
      observer.observe(box);
    });
  },

  pauseHiddenVideos: function () {
    document.querySelectorAll('.morph_video-model .morph_media-box video').forEach(function (video) {
      if (video.offsetParent === null && !video.paused) {
        video.pause();
      }
    });
  },

  checkCenter: function () {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var goingDown = scrollTop > lastTop;
    var winCenter = scrollTop + window.innerHeight / 2;

    document.querySelectorAll('.morph_how-it-started .morph_item').forEach(function (el) {
      var top = el.getBoundingClientRect().top + scrollTop;

      if (goingDown) {
        if (winCenter >= top) el.classList.add('active');
      } else {
        if (winCenter < top) el.classList.remove('active');
      }
    });

    lastTop = scrollTop;
  }
};

document.addEventListener('DOMContentLoaded', function () {
  customMethods.run();
});

window.addEventListener('scroll', function () {
  customMethods.checkCenter();
  customMethods.dripScroll();
  customMethods.cupTouch();
}, { passive: true });

window.addEventListener('resize', function () {
  customMethods._liquidTop = null;
  customMethods.dripScroll();
  customMethods.cupTouch();
  customMethods.pauseHiddenVideos();
}, { passive: true });
